export default class PlanWeekOrMonthFilter {
  constructor({ dateStart, dateEnd, employeeCode, departmentCode, establishmentCode }) {
    this.dateStart = dateStart;
    this.dateEnd = dateEnd;
    this.employeeCode = employeeCode;
    this.departmentCode = departmentCode;
    this.establishmentCode = establishmentCode;
  }
}
